import _t from 'i18n!nls/unified-common';

export const getPathwayDisclaimer = () => {
  const now = new Date();
  const endDate = new Date(now.getFullYear(), now.getMonth(), 1);
  const startDate = new Date(now.getFullYear() - 1, now.getMonth(), 1);
  return _t(
    `¹ Median salary and job opening data are sourced from Lightcast™ Job Postings Report. Data for job roles relevant to featured programs (#{startDate} - #{endDate})`,
    {
      startDate: startDate.toLocaleDateString(),
      endDate: endDate.toLocaleDateString(),
    }
  );
};

export const getXdpCareerImprovementPercentageDisclaimer = () => {
  return _t(
    '² Positive career outcome (e.g., new job, promotion, or raise) within six months of completion. Based on program graduate survey, United States 2022.'
  );
};
